import gql from 'graphql-tag'

export const GET_LANGUAGE_CODES_FOR_EVENT = gql`
  query getLanguageCodesForEvent($slug: String!) {
    getLanguageCodesForEvent(eventSlug: $slug) {
      id
      eventId
      translationKeys
    }
  }
`

export const GET_TRANSLATION = gql`
  query GetTranslation($eventId: ID!) {
    getTranslation(eventId: $eventId) {
      eventId
      translationsJSON
    }
  }
`

export const CREATE_OR_UPDATE_EVENT_TRANSLATION = gql`
  mutation createOrUpdateEventTranslation($eventId: ID!, $translationData: JSON!) {
    createOrUpdateEventTranslation(eventId: $eventId, translationData: $translationData) {
      id
      eventId
      translationsJSON
    }
  }
`

export const DELETE_EVENT_TRANSLATION = gql`
  mutation DeleteEventTraslation($eventId: ID!, $translationLng: String!) {
    deleteEventTraslation(eventId: $eventId, translationLng: $translationLng) {
      id
      eventId
      translationsJSON
    }
  }
`
